import { Input } from '@iwoca/orion';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import type { CompanyDetailsFormValues } from '../CompanyDetails.types';
import { FieldRow } from '../FieldRow';

export const TradingNameQuestion = () => {
    const { register } = useFormContext<CompanyDetailsFormValues>();

    return (
        <FieldRow
            htmlFor="tradingName"
            label={
                <FormattedMessage
                    id="_.your_company.trading_name"
                    defaultMessage="Trading name"
                />
            }
        >
            {/* eslint-disable-next-line iwoca/input-a11y */}
            <Input
                {...register('tradingName')}
                id="tradingName"
                className="fs-exclude"
            />
        </FieldRow>
    );
};
